// extracted by mini-css-extract-plugin
export var networks = "Networks-module--networks--1mAzc";
export var title = "Networks-module--title--8SjKT";
export var link = "Networks-module--link--21wV8";
export var small = "Networks-module--small--3DKK1 Networks-module--networks--1mAzc";